<template>
  <div class="main-content">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="d-flex flex-justify-between flex-align-center" style="width: 100%;">
      <!-- 搜索筛选 -->
      <el-form :inline="true" size="small" :model="formInline" class="user-search">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="formInline.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="search()">搜索</el-button>
          <el-button size="small" type="primary" v-buttonAuth="'system:role:add'" @click="handleEdit()">创建角色</el-button>
        </el-form-item>
      </el-form>
      <el-button type="danger" size="small" v-buttonAuth="'system:role:delete'" @click="removeRole()">删除</el-button>
    </div>
    <div class="main-table">
      <my-table :columns="tableForm.customColumns"  :tableData="tableForm.tableData" :loading="tableForm.isLoading"
        @selection-change="handleSelectionChange">
        <template #roleName="item">
          <div class="col-29f cs-pit" @click="handleEdit(null, item.row)">
            {{ item.row.roleName }}
          </div>
        </template>
        <el-table-column align="center" prop="userSex" label="操作">
          <template slot-scope="scope">
            <el-button type="text" v-buttonAuth="'system:role:permissions'"
              @click="openPermissions(scope.$index, scope.row)">权限</el-button>
          </template>
        </el-table-column>
      </my-table>
    </div>
    <div class="main-pagination">
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <el-dialog :title="title" :close-on-click-modal="false"  :visible.sync="editFormVisible" custom-class="form-dialog" width="70%"
      @click='closeDialog("edit")'>
      <my-form :form-config="formConfig.formItems" ref="editForm" :formRules="formConfig.formRules" @submit="submitForm"
        :dataForm="formConfig.dataForm">
      </my-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'设置权限'" :close-on-click-modal="false"  :visible.sync="treeData.dialogVisible" custom-class="form-dialog" width="70%"
      @click='closeRoleDialog()'>
      <el-tree class="roles-tree" ref="departTree" node-key="menuId" :props="{ label: 'menuName', children: 'children' }"
        :data="treeData.list" show-checkbox highlight-current :default-expand-all="true" @check-change="nodeClick" />
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeRoleDialog()'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitRoleMenu()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import { flatten } from '@/utils/util.js'
import { rolePage, roleAdd, roleEdit, roleRemove, roleMenuTree, roleMenuAssign } from '@/api/roleMG.js'
import { menuList } from '@/api/menuMG.js'
export default {
  components: {
    MyTable,
    Pagination,
    myForm,
  },
  data () {
    return {
      formInline: {
        roleName: '',
      },
      tableForm: {
        customColumns: [
          { label: '角色名称', prop: 'roleName', slot: 'roleName' },
        ],
        tableData: [
          // ...其他数据
        ],
        isLoading: false,
        checkList: []
      },
      treeData: {
        checkedKeys: [],
        list: [],
        activeData: {},
        dialogVisible: false,

      },
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加角色',
      // 编辑与添加
      formConfig: {
        formItems: [
          { type: 'input', prop: 'roleName', label: '角色名称', span: 12 },
        ],
        formRules: {
          roleName: [
            { required: true, message: '请输入角色名称', trigger: 'blur' },
          ],
        },
        dataForm: {
          roleName: '',
        }
      },
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.tableForm.checkList = [];
      const params = {
        pageNum: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        roleName: this.formInline.roleName
      }
      const res = (await rolePage(params)).data;
      this.tableForm.tableData = res.records;
      this.pageparm.total = res.total
    },
    search () {
      this.pageparm.currentPage = 1;
      this.getData()
    },
    handleSelectionChange (selection) {
      this.tableForm.checkList = selection;
    },
    handleEdit (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改角色'
        this.formConfig.dataForm = JSON.parse(JSON.stringify(row));
      } else {
        this.title = '新增角色'
        this.formConfig.dataForm = {
          roleName: '',
        }
      }
    },
    callFather (parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getData()
    },
    // 关闭编辑、增加弹出框
    closeDialog (dialog) {
      this.formConfig.dataForm = { ruleName: '' };
      this.$refs.editForm.$refs.form.resetFields();
      this.editFormVisible = false
    },
    async submitForm (editData) {
      const data = this.formConfig.dataForm;
      this.$refs.editForm.$refs.form.validate(async valid => {
        if (valid) {
          const res = await (data.roleId ? roleEdit(data) : roleAdd(data));
          this.closeDialog();
          await this.getData();
          this.$message.success(res.msg);
        } else {
          return false
        }
      })
    },
    async removeRole () {
      if (this.tableForm.checkList.length == 0) {
        this.$message.error("请选择要删除的角色");
        return
      }
      const data = this.tableForm.checkList.map(item => item.roleId);
      const roleRes = await roleRemove(data);
      this.$message.success(roleRes.msg);
      this.getData();
    },
    //角色权限操作
    async openPermissions (index, data) {
      this.treeData.dialogVisible = true;
      const checkedKey = _ => {
        setTimeout(_ => {
          const nodes = [];
          this.treeData.checkedKeys.forEach(item => {
            const node = this.$refs.departTree.getNode(item);
            if (node.isLeaf) nodes.push(item);
          });
          this.$refs.departTree.setCheckedKeys(nodes, true);
        }, 100);
      };
      const res = await roleMenuTree(data.roleId);
      this.treeData.checkedKeys = flatten(JSON.parse(JSON.stringify(res.data))).filter(item => item.select).map(item => item.menuId);
      console.log(this.treeData.checkedKeys);
      checkedKey();
      this.treeData.list = res.data;
      this.treeData.activeData = data;
      this.$forceUpdate()

    },
    nodeClick (data) {
    },
    async submitRoleMenu () {
      const data = this.$refs.departTree.getCheckedNodes(false, true).map(item => item.menuId);
      if (data.length === 0) {
        this.$message.error('请设置权限');
        return
      }
      const params = {
        "menuIdList": data,
        "roleId": this.treeData.activeData.roleId
      }
      const roleRes = await roleMenuAssign(params);
      this.$message.success(roleRes.msg);
      this.closeRoleDialog();
    },
    closeRoleDialog () {
      this.treeData = {
        list: [],
        checkedKeys: [],
        dialogVisible: false,
        activeData: {}
      };
    },

  },

}
</script>

<style lang="scss" scoped>
.user-search {
  margin-top: 20px;
}

.roles-tree {
  height: 500px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Role.vue